/**
 * MD-14 FE-LANDINGS - /citizen landing copy (VN-only long-tail)
 *
 * Per F-FE-LANDINGS.md Sec.4.1 - citizen segment is VN-only Day-1 (simplifies
 * copy, EN entries marked VN_ONLY sentinel).
 */

import type { LandingCatalog } from './landing-types';
import { VN_ONLY } from './landing-types';

export const citizenVi: LandingCatalog<'vi'> = {
  meta_title: 'Asklaw cho người dân - lao động, đất đai, hôn nhân, thuế cá nhân',
  meta_description:
    'Trợ lý pháp lý AI cho mọi người dân Việt Nam: tranh chấp lao động, thừa kế, ly hôn, đất đai, thuế thu nhập cá nhân.',
  hero_eyebrow: 'Cho mọi người dân Việt Nam',
  hero_headline: 'Tranh chấp lao động, đất đai, hôn nhân - hỏi miễn phí, có trích dẫn',
  hero_subhead:
    'Asklaw giúp bạn hiểu quyền lợi và nghĩa vụ pháp lý của mình: lao động, đất đai, ly hôn, thừa kế, thuế cá nhân - kèm Điều/Khoản từ luật chính thức.',
  cta_primary: 'Hỏi ngay',
  cta_secondary: 'Doc Pack đơn ly hôn',
  feature_1_title: 'Lao động và tranh chấp',
  feature_1_body:
    'Bộ luật Lao động 2019: hợp đồng, sa thải, BHXH, BHYT, BHTN, tranh chấp lao động.',
  feature_2_title: 'Đất đai và thừa kế',
  feature_2_body:
    'Luật Đất đai 2024 và Bộ luật Dân sự 2015: sổ đỏ, thừa kế, tranh chấp ranh giới.',
  feature_3_title: 'Hôn nhân và thuế cá nhân',
  feature_3_body:
    'Luật Hôn nhân và Gia đình 52/2014/QH13 và Luật Thuế TNCN: ly hôn, nuôi con, thu nhập.',
  pricing_intro: 'Hỏi miễn phí. Doc Pack đơn từ 199.000đ.',
  footer_disclaimer:
    'Asklaw là công cụ AI tham khảo thông tin pháp luật, KHÔNG phải dịch vụ tư vấn pháp lý. ' +
    'Mọi kết quả do AI tạo, có thể sai sót. Để được tư vấn chính thức cho vụ việc cụ thể, ' +
    'vui lòng liên hệ luật sư có chứng chỉ hành nghề.',
};

// Citizen segment is VN-only - every key marked VN_ONLY sentinel
export const citizenEn: LandingCatalog<'en'> = {
  meta_title: VN_ONLY,
  meta_description: VN_ONLY,
  hero_eyebrow: VN_ONLY,
  hero_headline: VN_ONLY,
  hero_subhead: VN_ONLY,
  cta_primary: VN_ONLY,
  cta_secondary: VN_ONLY,
  feature_1_title: VN_ONLY,
  feature_1_body: VN_ONLY,
  feature_2_title: VN_ONLY,
  feature_2_body: VN_ONLY,
  feature_3_title: VN_ONLY,
  feature_3_body: VN_ONLY,
  pricing_intro: VN_ONLY,
  footer_disclaimer: VN_ONLY,
};
